import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import * as ethers from 'ethers';
import { useTranslation } from 'react-i18next';

import { configJsonState } from "../../states/configJsonState";
import { useRecoilValue } from "recoil";

import { Spinner,SimpleGrid,Center,Box,Button,Text,Input,FormControl,Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,useDisclosure,useToast, Image} from '@chakra-ui/react';



type Props = {
  browserWalletAddress:string,
}
export const MarketplaceBrowserwalletButton: React.FC<Props> = (props) => {
  const [buttonText,setButtonText] = React.useState(`ブラウザ`);
  const [t, i18n] = useTranslation();
  const configStatus = useRecoilValue(configJsonState);

  const MarketplaceBrowserwalletButtonDivComponent = styled.div`
      margin-top: 0px;
  `;
  const MarketplaceBrowserwalletButtonComponent = styled.button`
    border: 0.5px solid rgba(239, 239, 239, 0.2);
    backdrop-filter: blur(50px);
    border-radius: 5px;
    background: linear-gradient(175.15deg, #F6F0F2 3.05%, #E89CEE 37.82%, #DAE4FF 68.31%, #B6CBFF 96.09%);
    width: 314px;
    height: 60px;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
    transition: all 0.5s;
    background-image: url('https://nfttopshot-template.onrender.com/template-images/btn-rainbow-square-bg.png');

    &:hover {
        opacity: 0.8;
        background-color: rgba(255, 255, 255, .2);
    }
  `;
  React.useEffect(()=>{
    (async() => {
      if (!(props.browserWalletAddress === ``)) {
        setButtonText(`${t('ブラウザ')}(${localStorage.getItem('walletAddressFromPK').substring(0,5)}...${localStorage.getItem('walletAddressFromPK').slice(-3)})`);
      }else{
        setButtonText(`${t(buttonText)}`)
      }
    })()
  },[]);
  return (
    <MarketplaceBrowserwalletButtonDivComponent>
        <div id="marketplacemesbrowserwalletdiv">
            <MarketplaceBrowserwalletButtonComponent 
              // id="marketplacemesbrowserwallet" 
              id="btn-default-mypage-browser"
              type="button" 
              onClick={()=>
                {
                  window.open(`https://tofunft.com/${configStatus.lang}/user/${props.browserWalletAddress}/items/in-wallet`);
                }
              }
            >
                <Image
                  w={'40px'}
                  src="https://free-icons.net/wp-content/uploads/2020/09/symbol011.png"
                  display={'inline-block'}
                  mt={'-5px'}
                />
                <Text
                  display={'inline-block'}
                  fontSize={'19px'}
                  mb={`0px`}
                  fontWeight={'bold'}
                  color={'rgb(98, 171, 212)'}
                >
                {buttonText}
                </Text>
            </MarketplaceBrowserwalletButtonComponent>
        </div>
    </MarketplaceBrowserwalletButtonDivComponent>
  );
};